<style lang="scss" scoped>
  @import '../../../sass/_variables';

  .integrations {
    flex-flow: column nowrap;

    &__title {
      font-size: 1rem;
      font-weight: 600;
      line-height: 14px;
      color: $gray-dark;
    }

    &__list {
      display: flex;
      align-items: center;
    }

    &__item {
      flex-grow: 1;
      display: flex;
      padding: 8px 0px;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #dee2e6;

      &--borderless {
        border-top: none;
      }

      &-key,
      &-secret {
        flex: 1;
        font-size: 12px;
        color: $gray-light;
        padding: 2px 0 1px;

        &-title {
          font-size: 12px;
          color: $gray-dark;
          margin-right: 2px;
        }
      }
    }
  }
</style>

<template>
  <div>
    <i
      class="fa fa-spin fa-circle-o-notch"
      v-if="loading"
    />
    <div
      class="form-group"
      v-else
    >
      <p class="form-text">
        {{ __('Configure seu acesso ao SAP e o adicione App Key e App Secret para continuar.') }}
      </p>
      <form @submit.prevent="save()">
        <div class="row">
          <div class="col-6">
            <label class="lg">Application Key</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_id"
                required="required"
              >
            </p>
          </div>
          <div class="col-6">
            <label class="lg">Application Secret</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_secret"
                required="required"
              >
            </p>
          </div>
        </div>
        <div class="text-right">
          <p>
            <button
              class="btn btn-sm btn-box"
              type="submit"
              :disabled="disabled"
            >
              {{ __('Adicionar') }}
            </button>
          </p>
        </div>
      </form>
      <div
        class="integrations"
        v-if="integrations && integrations.length > 0"
      >
        <label class="lg">{{ __('Integrações SAP') }}</label>
        <div
          class="integrations__list"
          v-for="(token, index) of integrations"
          :key="index"
        >
          <div
            class="integrations__item"
            :class="{ 'integrations__item--borderless': index === 0 }"
          >
            <span class="integrations__item-key"><span class="integrations__item-key-title">Application Key:</span><span class="integrations__item-value">{{ token.config.client_id }}</span></span>
          </div><a
            class="ml-3"
            href="#"
            @click.prevent="destroy(token, index)"
            v-b-tooltip.bottomleft="__('Remover Integração')"
          >
            <IconTrash :size="18" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      config: {
        multiple: true,
        client_id: '',
        client_secret: '',
        options: {
          decrypt: true,
        },
      },
      integration: {
        name: 'sap',
      },
    };
  },

  computed: {
    disabled () {
      if (this.integration.id) {
        return this.config.client_secret.length > 0 && this.config.client_secret.length < 16;
      }

      return this.config.client_secret.length < 16;
    },
  },

  methods: {
    reset () {
      this.config = {
        multiple: true,
        client_id: '',
        client_secret: '',
        options: {
          decrypt: true,
        },
      };
    },

    async destroy (token, index) {
      const text = this.__('Esta ação não poderá ser desfeita!');

      if (! await Confirm(this.__('Deseja mesmo excluir?'), text)) {
        return;
      }

      this.$http.delete(`/integration/config/${token.id}`)
        .then(() => this.integrations.splice(index, 1));
    },
  },
};
</script>
